import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BaseService } from '../base.service';

// Interfaces
import { StatusType } from '../../models/interfaces/common/common';
import { Observable, Subject } from 'rxjs';

// Servicios
import { AdditionalbaseService } from '../../services/common/additionalbase.service';
import { NotifyService } from '../notify/notify.service';
import { EncryptedService } from './encrypted.services';
import { UserData } from 'src/app/models/class/common/UserData';
import { formatNumber } from '@angular/common';
// import { Message } from '@angular/compiler/src/i18n/i18n_ast';
// import { validateNumber, formatDecimal, setNotifier } from 'src/app/shared/sc-input/sc-input/sc-input.component';
import { IUserData } from 'src/app/models/interfaces/common/IUserData';
import { IConfiguration } from 'src/app/models/interfaces/common/IConfiguration';

@Injectable()
export class CommonService extends BaseService {

  public static decimal = '1.2';
  public static format = 'en-US';
  private configurationSource: Subject<IConfiguration> = new Subject<IConfiguration>();

  configuration$: Observable<IConfiguration> = this.configurationSource.asObservable();

  constructor(public https: HttpClient, public override _additionalService: AdditionalbaseService, private _notifyService: NotifyService, private _encrypted: EncryptedService) {
    super(https, _additionalService, 'common');
  }

  configuration(response: IConfiguration) {
    this.configurationSource.next(response);
  }

  // Menu
  getMenu(objeto: any): Observable<any> {
    return this._additionalService.wrapperObservable(this.optain('menu/SC_Obtener', objeto));
  }

  // Listado de Productos
  getProducts() {
    return this._additionalService.wrapperPromise(this.get('product/SC_Obtener'));
  }

  // Estatus de los pruductos dependiendo el contexto

  getStatusProduct(place: StatusType) {
    const stringConection = `status/${place}`;
    return this._additionalService.wrapperPromise(this.get(stringConection));
  }

  getSearch(): Observable<any> {
    return this._additionalService.wrapperObservable(super.get('test'));
  }

  postFilter(object: any, pagina: number, cantidad: number): Observable<any> {
    const stringConection = `test/?pagina=${pagina}&cantidad=${cantidad}`;
    return this._additionalService.wrapperObservable(this.optain(stringConection, object));
  }

  getCurrenciesProduct() {
    return this._additionalService.wrapperPromise(this.get('currencies/SC_Obtener'));
  }

  getUnitsTimeListProduct() {
    return this._additionalService.wrapperPromise(this.get('unitstimelist'));
  }

  getRankTimeList() {
    return this._additionalService.wrapperPromise(this.get('RankTimeList'));
  }

  getCivilStatus() {
    return this._additionalService.wrapperPromise(this.get('CivilStatus'));
  }

  getGender() {
    return this._additionalService.wrapperPromise(this.get('Gender/SC_Obtener'));
  }

  // Obtiene las categorias de un plan
  getCategories() {
    return this._additionalService.wrapperPromise(this.get('Categories'));
  }

  // Obtiene los tipos de aplicacion
  getAplicationForm() {
    return this._additionalService.wrapperPromise(this.get('AplicationForm'));
  }

  get_TipoIdentificador(TIPOCLIENTE: any): Observable<any> {
    const stringConection = `Auxiliar/Mtipide/SC_Obtener/${TIPOCLIENTE}`;
    return this._additionalService.wrapperObservable(super.get(stringConection));
  }

  get_SC_ObtenerOcupaciones(): Observable<any> {
    const stringConection = `Auxiliar/Ocupacion/SC_ObtenerTodos`;
    return this._additionalService.wrapperObservable(super.get(stringConection));
  }

  copy(objetoCopia: any) {
    const retorno = JSON.parse(JSON.stringify(objetoCopia));
    return retorno;
  }

  SC_ObtenerRamo() {
    return this._additionalService.wrapperObservable(super.get('Ramo/Ramo/SC_Obtener'));
  }

  SC_ObtenerRamoParaEmision() {
    return this._additionalService.wrapperObservable(super.get('Ramo/Ramo/SC_ObtenerParaEmision'));
  }

  SC_ObtenerSubRamo(ramo: number) {
    const saveURL = this.base_url;
    // this.base_url = `${this.base_url}/ramo/RamoSubRamo`;
    const result = this.SC_Route_Buscar([{ 'name': 'RAMO', 'data': ramo }], '/ramo/RamoSubRamo');
    // this.base_url = saveURL;
    return result;
  }

  idFormat(id: string) {
    if (id.length < 11) {
      const index = 11 - id.length;
      for (let i = 0; i < index; i++) {
        id = '0' + id;
      }

      return id;
    } else {
      return id;
    }
  }

  compareObject(firstCommit: any, formValue: any) {
    const propFormValue = Object.keys(formValue);
    const propFirstCommit = Object.keys(firstCommit);
    if (propFormValue.length > propFirstCommit.length || propFormValue.length < propFirstCommit.length) {
      return true;
    } else if (propFormValue.length === propFirstCommit.length) {
      let missing = propFormValue.filter(item => propFirstCommit.indexOf(item) < 0);
      if (missing.length > 0) {
        return true;
      } else {
        return propFirstCommit.some(element =>
          formValue[element] !== firstCommit[element]
        );
      }
    }
    return false;
  }

  notSymbols(event, punto?: boolean, guion?: boolean) {
    if (punto) {
      if (!((event.keyCode > 95 && event.keyCode < 106)
        || (event.keyCode > 45 && event.keyCode < 58)
        || event.keyCode === 8)) {
        return false;
      }
    } else if (guion) {
      if (!((event.keyCode > 95 && event.keyCode < 106)
        || (event.keyCode > 45 && event.keyCode < 58)
        || event.keyCode === 8)) {
        return false;
      }

    } else {
      if (!((event.keyCode > 95 && event.keyCode < 106)
        || (event.keyCode > 47 && event.keyCode < 58)
        || event.keyCode === 8)) {
        return false;
      }
    }
    return false;
  }

  onlyNumbers(event: any, dot = false) {
    let mensage = '';

    if (event.key === 'Enter') {
      return;
    }


    const pattern = /[0-9.]/;
    if (!pattern.test(event.key)) {
      event.preventDefault();
      return;
    } else if (event.target.value.toString().includes('.') && event.key === '.') {
      mensage = `Valor no permitido`;
    }
  }

  notNumbers(event: any, dot = false) {
    let mensage = '';

    if (event.key === 'Enter') {
      return;
    }


    const pattern = /[0-9.]/;
    if (pattern.test(event.key)) {
      event.preventDefault();
      return;
    } else if (event.target.value.toString().includes('.') && event.key === '.') {
      mensage = `Valor no permitido`;
    }
  }

  validDecimalNumber(event: any, int: number, decimal: number = 0) {
    if (decimal) {
      int = int + decimal;
    }

    this.validateNumber(event, int, decimal);
  }

  //
  // notSymbols(event) {
  //   var k;
  //   k = event.charCode;
  //   return((k > 64 && k < 91) || (k > 96 && k < 123) || k == 8 || k == 32 || (k >= 48 && k <= 57));
  // }

  letterOnly(event) {
    var k;
    k = event.charCode;
    return ((k > 64 && k < 91) || (k > 96 && k < 123) || k == 8);
  }



  getUser(): IUserData {
    const aux = this._encrypted.decrypted(localStorage.getItem('user'));
    const usuario = JSON.parse(aux);
    return usuario;
  }



  numberLenght(value, minLenght, maxLenght) {
    // Ejemplo de uso
    // tslint:disable-next-line: max-line-length
    // <input matInput placeholder="%Sobre-prima" name="POR_SOB_PRI" [ngModel]="aseguradoEndoso.POR_SOB_PRI" type="number" (ngModelChange)="aseguradoEndoso.POR_SOB_PRI = _common.numberLenght($event, 0, 100)">
    if (value >= minLenght && value <= maxLenght) { return value; }
  }


  formatDecimal(event: any, format: boolean = true): number {
    return this.formatDecimal(event, format);

  }

  preventPaste(event: any, int = 0, decimal = 0) {
    if (decimal) {
      int = int + decimal;
    }

    setNotifier(this._notifyService);
    this.validateNumber(event, int, decimal);
  }

  validateNumber(event: any, int: number = 0, decimal: number = 0) {

    setNotifier(this._notifyService);
    this.validateNumber(event, int, decimal);
  }

  searchFilter(filter?: any, servicio?: any) {
    const url: any = (window.location.href).split('#');
    if (filter) {
      if (filter.document_name) {
        if (sessionStorage.getItem(filter.document_name)) {
          return JSON.parse(sessionStorage.getItem(filter.document_name));
        } else {
          return [];
        }
      } else if (filter && servicio) {
        for (let i = 0; i < sessionStorage.length; i++) {
          const key = sessionStorage.key(i);
          if (servicio.document_name === key.toString()) {
            sessionStorage.setItem(servicio.document_name, JSON.stringify([]));
            return [];
          }
        }
      } else {
        sessionStorage.setItem(url[1], JSON.stringify([]));
        return [];
      }
    } else {
      if (sessionStorage.getItem(url[1])) {
        return JSON.parse(sessionStorage.getItem(url[1]));
      } else {
        return [];
      }
    }
  }

  // Estatus de Especialidad
  getEspEstatus() {
    return this._additionalService.wrapperPromise(this.get('Status/GetStatus/ESP_SAL'));
  }
}
function setNotifier(_notifyService: NotifyService) {
  throw new Error('Function not implemented.');
}

